<template>
  <div>
    <v-row>
      <v-col
        col-md-12
        class="infText text-center"
        v-if="browserSize.xs === true || browserSize.sm === true"
      >
        <div class="display-1 font-weight-black grey--text text-center">
          O mnie
        </div>
      </v-col>
      <v-col col-md-12 class="infText text-center" v-else>
        <div class="display-2 font-weight-black grey--text text-center">
          O mnie
        </div>
      </v-col>
    </v-row>

    <v-row v-if="browserSize.xs === true || browserSize.sm === true">
      <v-col class="col-12">
        <v-img src="../assets/about.jpg" aspect-ratio="1.4" contain></v-img>
        <p class="font-weight-black grey--text text-center name">
          dr Aleksandra Skomudek
        </p>
      </v-col>
      <v-col class="col-12">
        <p class="aboutText">
          Zainteresowania - terapia manualna, w tym działanie na mięśniach,
          stawach kończyn i kręgosłupa, terapia czaszkowo-krzyżowa, praca w
          obrębie kości miednicy; holistyczne podejście do pacjenta, regularne
          pogłębianie wiedzę w dziedzinie terapii ortopedycznej. W pracy kieruję
          się indywidualnym podejściem do pacjenta, wykorzystując różne techniki
          i metody fizjoterapeutyczne w celu uzyskania najlepszego efektu
          terapeutycznego. Fizjoterapia jest moją pasją.
        </p>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col class="col-5">
        <v-img src="../assets/about.jpg" aspect-ratio="1.4" contain></v-img>
        <p class="font-weight-black grey--text text-center name">
          dr Aleksandra Skomudek
        </p>
      </v-col>
      <v-col class="col-6 aboutText">
        Zainteresowania - terapia manualna, w tym działanie na mięśniach,
        stawach kończyn i kręgosłupa, terapia czaszkowo-krzyżowa, praca w
        obrębie kości miednicy; holistyczne podejście do pacjenta, regularne
        pogłębianie wiedzę w dziedzinie terapii ortopedycznej. W pracy kieruję
        się indywidualnym podejściem do pacjenta, wykorzystując różne techniki i
        metody fizjoterapeutyczne w celu uzyskania najlepszego efektu
        terapeutycznego. Fizjoterapia jest moją pasją.
      </v-col>
    </v-row>

    <v-row class="infor">
      <v-col
        col-md-12
        class="infText text-center"
        v-if="browserSize.xs === true || browserSize.sm === true"
      >
        <div class="display-1 font-weight-black grey--text text-center">
          Kwalifikacje
        </div>
        <div class="textWhyPhone">
          Zależy mi przede wszystkim na zdrowiu i zadowoleniu pacjentów, dlatego
          nieustannie się szkolę i podnoszę swoje kwalifikacje.
        </div>
        <p class="paragraph">Certyfikowane kursy specjalistyczne:</p>
        <li>Osteopatyczna diagnostyka i leczenie narządów trzewnych - 2020</li>
        <li>
          Neurorozwojowa diagnostyka i rehabilitacja niemowląt i dzieci
          starszych - 2017
        </li>
        <li>
          Terapia czaszkowo-krzyżowa całości kursu, moduły I - VII - 2015 - 2017
        </li>
        <li>Ocena i trening funkcjonalny wg koncepcji FMS - 2015</li>
        <li>Kurs Postural Restoration Instytute: Odbudowa miednicy - 2015</li>
        <li>
          Kurs Postural Restoration Instytute: Poprawa funkcji kompleksu
          piersiowo – brzusznego - 2014
        </li>
        <li>
          Kurs Postural Restoration Instytute: Miokinematyczna odbudowa wzorców
          zespołu lędźwiowo – miedniczno – udowego - 2014
        </li>
        <li>Elektromiografia funkcjonalna w badaniach naukowych - 2013</li>
        <li>Kurs Współczesne metody diagnozowania tkanek miękkich - 2013</li>
        <li>Kurs Traumatologia sportowa - 2012</li>
        <li>Metoda McKenzie, moduł B - 2012</li>
        <li>Metoda McKenzie, moduł A - 2012</li>
        <li>PNF kurs podstawowy - 2011</li>
        <li>
          Kurs: Badanie i fizjoterapia funkcjonalna w uszkodzeniach stawu
          kolanowego, Moduł I i II - 2010
        </li>
        <li>
          Kinesiology Taping zgodnie ze standardami K-Active Association - 2009
        </li>
        <p class="paragraph">Szkolenia specjalistyczne:</p>
        <li>
          Szkolenie metodyczne zakończone certyfikatem: „Magnetostymulacja,
          ledoterapia, magnetoledoterapia - najnowsze procedury fizykoterapii” -
          2012
        </li>
        <li>
          Szkolenie metodyczne zakończone certyfikatem:
          „Równowaga-Biomechaniczne spojrzenie na podstawę funkcjonowania
          człowieka” - 2012
        </li>
      </v-col>
      <v-col col-md-12 class="infText text-center" v-else>
        <div class="display-2 font-weight-black grey--text text-center">
          Kwalifikacje
        </div>
        <div class="textWhy">
          Zależy mi przede wszystkim na zdrowiu i zadowoleniu pacjentów, dlatego
          nieustannie się szkolę i podnoszę swoje kwalifikacje.
        </div>
        <p class="paragraph">Certyfikowane kursy specjalistyczne:</p>
        <li>Osteopatyczna diagnostyka i leczenie narządów trzewnych - 2020</li>
        <li>
          Neurorozwojowa diagnostyka i rehabilitacja niemowląt i dzieci
          starszych - 2017
        </li>
        <li>
          Terapia czaszkowo-krzyżowa całości kursu, moduły I - VII - 2015 - 2017
        </li>
        <li>Ocena i trening funkcjonalny wg koncepcji FMS - 2015</li>
        <li>Kurs Postural Restoration Instytute: Odbudowa miednicy - 2015</li>
        <li>
          Kurs Postural Restoration Instytute: Poprawa funkcji kompleksu
          piersiowo – brzusznego - 2014
        </li>
        <li>
          Kurs Postural Restoration Instytute: Miokinematyczna odbudowa wzorców
          zespołu lędźwiowo – miedniczno – udowego - 2014
        </li>
        <li>Elektromiografia funkcjonalna w badaniach naukowych - 2013</li>
        <li>Kurs Współczesne metody diagnozowania tkanek miękkich - 2013</li>
        <li>Kurs Traumatologia sportowa - 2012</li>
        <li>Metoda McKenzie, moduł B - 2012</li>
        <li>Metoda McKenzie, moduł A - 2012</li>
        <li>PNF kurs podstawowy - 2011</li>
        <li>
          Kurs: Badanie i fizjoterapia funkcjonalna w uszkodzeniach stawu
          kolanowego, Moduł I i II - 2010
        </li>
        <li>
          Kinesiology Taping zgodnie ze standardami K-Active Association - 2009
        </li>
        <p class="paragraph">Szkolenia specjalistyczne:</p>
        <li>
          Szkolenie metodyczne zakończone certyfikatem: „Magnetostymulacja,
          ledoterapia, magnetoledoterapia - najnowsze procedury fizykoterapii” -
          2012
        </li>
        <li>
          Szkolenie metodyczne zakończone certyfikatem:
          „Równowaga-Biomechaniczne spojrzenie na podstawę funkcjonowania
          człowieka” - 2012
        </li>
      </v-col>
    </v-row>
    <v-img
      src="../assets/skutecznafizjoterapia.jpg"
      alt="fizjoterapia"
      height="300px"
      ><div class="display-2 color font-weight-bold mb-3 imageDiv">
        Wytrwałość
      </div></v-img
    >
  </div>
</template>

<script>
export default {
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.imageDiv {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.color {
  text-shadow: 2px 2px #3e2723;
  color: #f5f5f5;
}
.infText {
  margin: auto;
}
.v-application .grey--text {
  color: #414149 !important;
}
.textWhy {
  margin-top: 25px;
  text-align: center;
}
.textWhyPhone {
  margin-top: 25px;
  margin-bottom: 25px;
  text-align: justify;
  text-align-last: left;
}
.name {
  margin: 10px;
  color: #414149 !important;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: auto;
  max-height: 50%;
  margin-left: 4vw;
}
.col {
  text-align: justify;
  text-align-last: center;
}
.textCenter {
  text-align-last: left;
}
.aboutText {
  text-align-last: left;
  display: flex;
  align-items: center;
  justify-content: center;
}
.paragraph {
  font-weight: bold;
  margin-top: 10px;
}
h1 {
  margin: auto;
}
</style>
